import React from 'react';

const Facebook = props => (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M26.8543 0.333542H1.76716C1.16384 0.333542 0.676413 0.820969 0.676413 1.42429V26.5115C0.676413 27.1148 1.16384 27.6022 1.76716 27.6022H26.8543C27.4577 27.6022 27.9451 27.1148 27.9451 26.5115V1.42429C27.9451 0.820969 27.4577 0.333542 26.8543 0.333542ZM23.7048 8.29259H21.5267C19.819 8.29259 19.4884 9.10383 19.4884 10.2968V12.9249H23.5651L23.0333 17.039H19.4884V27.6022H15.2379V17.0424H11.6827V12.9249H15.2379V9.89121C15.2379 6.37014 17.3887 4.45111 20.5314 4.45111C22.038 4.45111 23.3299 4.56359 23.7082 4.61472V8.29259H23.7048Z" fill="currentColor" />
    </svg>
)

export default Facebook;